import { PartialBatchOperationSuccessError as l } from "@hprofits/shared/errors";
const s = 10, h = async (o, c) => {
  const r = [];
  for (let t = 0; t < o.length; t += s) {
    const a = o.slice(t, t + s), n = await Promise.allSettled(a.map((e) => c(e)));
    r.push(...n.filter((e) => e.status === "rejected"));
  }
  if (r.length > 0)
    throw new l(r);
};
export {
  s as BULK_CHUNK_SIZE,
  h as runBatchOrThrow
};
//# sourceMappingURL=run-batch-or-throw.js.map
